
export function getVersion(site){
    switch (site){
        case 'usSantaElisa': return '1.0.2'
        case 'usBatatais': return '1.0.8'
        case 'usSonora': return '1.0.6'
        case 'usMonteAlegre': return '1.0.2'
        case 'usCevasa': return '0.18'
        case 'usLins': return '0.10'
        case 'usJbAlcoolquimica': return '0.0.5'
        case 'usTeste1': return '0.0.1'
        default: return null
    }
}